import { render, staticRenderFns } from "./edit-feature.component.vue?vue&type=template&id=7c2c7e82&scoped=true&"
import script from "./edit-feature.component.vue?vue&type=script&lang=js&"
export * from "./edit-feature.component.vue?vue&type=script&lang=js&"
import style0 from "./edit-feature.component.vue?vue&type=style&index=0&id=7c2c7e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2c7e82",
  null
  
)

export default component.exports